var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34961 -3.10156V2.66211C8.34952 11.579 2.86215 17.9858 0.694336 20.166C0.150027 20.7134 0.509411 21.739 1.35547 21.7002C3.01638 21.624 6.18609 21.3816 9.55957 20.6113C12.9223 19.8435 16.5452 18.5383 19.0635 16.2998L19.2109 16.1689V-3.10156H8.34961Z",
    fill: "white",
    stroke: "#DEDFE3",
    strokeWidth: 0.87846
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleTriangle);
export default __webpack_public_path__ + "static/media/bubble-triangle.e1f0bb52c96a1511332d02d9c6743914.svg";
export { ForwardRef as ReactComponent };